const faqItems = [
  {
    q: '黑料爆料吃瓜网是什么类型的网站？',
    a: '黑料爆料吃瓜网是一个专注娱乐圈八卦和明星黑料的资讯聚合平台，实时同步51吃瓜与17c吃瓜热门内容，为吃瓜群众提供最新鲜、最全面的娱乐爆料。我们追踪明星负面新闻、绯闻、行业争议和社会热点，是吃瓜群众每日必刷的瓜田。',
  },
  {
    q: '网站内容多久更新一次？',
    a: '我们的编辑团队全天候监控各大社交平台、娱乐圈动态和网络爆料渠道，做到24小时不间断更新。重大黑料和突发事件会在30分钟内上线，确保吃瓜群众第一时间获取最新大瓜。51吃瓜和17c黑料爆料内容也会实时同步。',
  },
  {
    q: '如何辨别爆料的真实性？',
    a: '我们对每一条爆料都进行多方交叉验证，标注信息来源和可信度等级。对于未经证实的传闻会明确标注"待核实"，对有实锤证据的黑料会标注"已证实"。我们也鼓励吃瓜群众理性吃瓜，不轻信、不传谣。',
  },
  {
    q: '可以投稿或提供爆料线索吗？',
    a: '当然可以！我们欢迎吃瓜群众投稿和提供第一手爆料线索。您可以通过页面底部的"投稿爆料"区域提交信息，我们会严格保护爆料人隐私。对于高质量独家爆料，还有机会获得奖励。',
  },
  {
    q: '手机上可以浏览黑料爆料吃瓜网吗？',
    a: '黑料爆料吃瓜网完美适配手机、平板和电脑等各类设备。您可以将网站添加到手机桌面，像使用App一样随时随地刷瓜。我们还提供移动端专属入口，为您带来更流畅的吃瓜体验。',
  },
  {
    q: '网站内容会涉及侵权吗？如何保护当事人权益？',
    a: '我们严格遵循相关法律法规，所有内容均为公开信息的整理和报道。如涉及不实信息或侵权内容，当事人或相关方可联系我们的法务团队，我们会在核实后第一时间处理。我们致力于在吃瓜与尊重隐私之间找到平衡。',
  },
];

export default function SectionFaq() {
  const [openIndex, setOpenIndex] = (() => {
    const [val, setVal] = (() => {
      let v = 0;
      const set = (n: number) => { v = n; };
      return [v, set] as const;
    })();
    return [val, setVal] as const;
  })();

  const toggleFaq = (idx: number) => {
    // Simple accordion toggle through DOM
    const details = document.querySelectorAll('#faq details');
    details.forEach((d, i) => {
      if (i !== idx) (d as HTMLDetailsElement).open = false;
    });
  };

  return (
    <section id="faq" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">吃瓜必读</h2>
          <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-semibold whitespace-nowrap">FAQ</span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 pl-4">关于黑料爆料吃瓜网的常见问题，帮助吃瓜群众更好地使用本站</p>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <details key={i} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer">
              <summary
                className="flex items-center justify-between p-4 md:p-5 font-semibold text-sm md:text-base text-foreground-900 list-none"
                onClick={() => toggleFaq(i)}
              >
                <span className="pr-4">{item.q}</span>
                <span className="shrink-0 w-8 h-8 rounded-full bg-background-200 flex items-center justify-center group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-arrow-down-s-line text-lg group-open:rotate-180 transition-transform"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}